module.exports = __webpack_public_path__ + "1c6d01e9.svg";